export default __webpack_public_path__ + "static/media/ms2.f564b444.png";